module.exports = __webpack_public_path__ + "static/media/10.b7c7c737.jpeg";